import { useState } from 'react';

const carouselItems = [
  {
    id: 1,
    title: '暑期档热映精选',
    desc: '今年夏天最值得一看的电影都在这里，从科幻大片到温情喜剧，让你足不出户享受影院级观影体验',
    tag: '专题策划',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20visual%20with%20warm%20golden%20sunset%20lighting%2C%20cinema%20elements%2C%20vibrant%20coral%20and%20amber%20color%20palette%2C%20modern%20minimal%20style%2C%20entertainment%20concept&width=560&height=400&seq=cr-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '高分韩剧合集',
    desc: '豆瓣8.5分以上口碑韩剧一网打尽，从浪漫爱情到悬疑烧脑，满足你的追剧欲望',
    tag: '口碑推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20visual%20with%20romantic%20warm%20lighting%2C%20elegant%20aesthetic%20elements%2C%20soft%20peach%20and%20rose%20tones%2C%20modern%20minimalist%20style%2C%20quality%20entertainment%20concept&width=560&height=400&seq=cr-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '经典港片修复版',
    desc: '高清修复经典港片系列，重温周星驰喜剧、成龙动作、王家卫文艺等永恒经典',
    tag: '经典重映',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20film%20visual%20with%20nostalgic%20warm%20neon%20lighting%2C%20retro%20cinema%20elements%2C%20amber%20and%20deep%20red%20tones%2C%20vintage%20modern%20style%2C%20timeless%20movie%20concept&width=560&height=400&seq=cr-03-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '动画电影嘉年华',
    desc: '全球热门动画电影大集合，从皮克斯精品到吉卜力经典，还有国产动画新势力',
    tag: '动画盛宴',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20animation%20film%20festival%20visual%20with%20magical%20warm%20lighting%2C%20whimsical%20elements%2C%20bright%20coral%20and%20golden%20tones%2C%20modern%20minimal%20style%2C%20creative%20cinema%20concept&width=560&height=400&seq=cr-04-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            精心策划的专题内容，发现更多优质影视资源
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <CarouselCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CarouselCard({ item }: { item: typeof carouselItems[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group relative bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer flex flex-col sm:flex-row">
      <div className="relative w-full sm:w-[240px] lg:w-[280px] aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200 shrink-0">
        {!imgError ? (
          <img
            src={item.imageUrl}
            alt={item.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
        ) : null}
      </div>
      <div className="p-5 md:p-6 flex flex-col justify-center flex-1">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 w-fit">
          {item.tag}
        </span>
        <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed">
          {item.desc}
        </p>
      </div>
    </div>
  );
}